import { SuitcaseRollingIcon } from "@phosphor-icons/react";
import { useTranslations } from "use-intl";

export const BaggageIncluded = () => {
  const t = useTranslations();

  return (
    <div className="flex items-center gap-1">
      <SuitcaseRollingIcon size={16} />
      <span className="text-xs leading-[15px] text-text-tertiary">
        {t("flights.included")}
      </span>
    </div>
  );
};
